import './style.css';

import { useSelector } from 'react-redux';


import { Link, useNavigate } from 'react-router-dom';
import store from '../../store/store';
const selectWindowInnerSize = (state) => state.windowInnerSize;
const selectNavigateBackLocation = (state) => state.navigateBackLocation;

export default function PrivacyPolicy() {
  const windowInnerSize = useSelector(selectWindowInnerSize);
  const navigateBackLocation = useSelector(selectNavigateBackLocation);

  const navigate = useNavigate();
  // const location = useLocation();

  return (
    <div
      id="PrivacyPolicy"
      className="PrivacyPolicy Page headline"
      style={{ height: windowInnerSize.height }}
    >
      <img
        src={'/images/back-page.png'}
        alt="Back to previous page"
        className="CookiePolicy__back-btn"
        onClick={() => {
          // console.log(location.state?.from);
          console.log(navigateBackLocation.page);

          navigate(navigateBackLocation.page);
          if (navigateBackLocation.page === '/cookie-policy') {
            navigate('/cookie-policy');
            store.dispatch({
              type: 'ui/navigateBackLocation/add',
              payload: {
                page: '/',
                from: navigateBackLocation.from,
                typePage: navigateBackLocation.typePage,
              },
            });
          } else {
            navigate('/');
          }
        }}
      />

      <div
        style={{
          padding: ' 2vw 5vw 5vw',
          maxWidth: '1400px',
          margin: '0 auto',
        }}
      >
        <h1>PassionStocks – Privacy Policy</h1>
        <br />
        <p>
          <strong>Last Updated: January 5, 2026</strong>
        </p>
        <p>
          PassionStocks, Inc. (&ldquo;PassionStocks,&rdquo; &ldquo;we,&rdquo; &ldquo;us,&rdquo; or &ldquo;our&rdquo;) values your privacy. This Privacy Policy explains how we collect, use, share, and protect your personal information when you access or use the PassionStocks website, waitlist, platform, and related services (collectively, the &ldquo;Platform&rdquo;).
        </p>
        <p>
          By using the Platform, you consent to the practices described in this Privacy Policy.
        </p>
        <br />
        <h2>
          <u>1. Information We Collect</u>
        </h2>
        <p>
          We collect the following categories of personal information:
        </p>
        <p>
          <strong>1.1 Account Information</strong><br />
          When you join the waitlist or create an account, we may collect your name, username or handle, email address, phone number (if provided), and login credentials.
        </p>
        <p>
          <strong>1.2 Transaction Information</strong><br />
          If you engage in paid features, we collect transaction-related information such as purchase details, payout information, and transaction history. Payment details are processed by third-party payment providers and are not stored directly by PassionStocks.
        </p>
        <p>
          <strong>1.3 Profile &amp; Content Information</strong><br />
          Information you choose to share on the Platform, including creator profiles, shoutout activity, profile images, and other content.
        </p>
        <p>
          <strong>1.4 Technical Data</strong><br />
          Information automatically collected when you use the Platform, such as IP address, device type, browser type, operating system, cookies, and usage activity.
        </p>
        <p>
          <strong>1.5 Communications</strong><br />
          Information you provide when contacting us, including emails, support requests, or other communications.
        </p>
        <p>
          <strong>1.6 Third-Party Integrations</strong><br />
          If you connect third-party services (such as social media accounts), we may receive limited information from those services, such as profile handles or follower counts, in accordance with your settings and the third party&rsquo;s policies.
        </p>
        <p>
          We do not knowingly collect personal information from children under the age of 13 (or under 16 where applicable law requires).
        </p>
        <br />
        <h2>
          <u>2. How We Use Information</u>
        </h2>
        <p>
          We use personal information to:
        </p>
        <ul>
          <li>
            <p>Provide, operate, and improve the Platform</p>
          </li>
          <li>
            <p>Enable Platform features and functionality</p>
          </li>
          <li>
            <p>Process transactions and deliver shoutouts</p>
          </li>
          <li>
            <p>Manage creator payouts</p>
          </li>
          <li>
            <p>Authenticate users and maintain security</p>
          </li>
          <li>
            <p>Prevent fraud, abuse, or unauthorized activity</p>
          </li>
          <li>
            <p>Communicate with you regarding accounts, updates, and support</p>
          </li>
          <li>
            <p>Comply with legal and regulatory obligations</p>
          </li>
        </ul>
        <br />
        <h2>
          <u>3. How We Share Information</u>
        </h2>
        <p>
          We share personal information only as necessary:
        </p>
        <p>
          <strong>Service Providers</strong> – With vendors that support hosting, analytics, communications, and customer support
        </p>
        <p>
          <strong>Payment Processors</strong> – To process payments and payouts securely
        </p>
        <p>
          <strong>Platform Visibility</strong> – Certain information (such as usernames or handles) may be visible to others as part of Platform functionality
        </p>
        <p>
          <strong>Legal &amp; Compliance</strong> – To comply with applicable laws or legal processes
        </p>
        <p>
          <strong>Business Transfers</strong> – In connection with a merger, acquisition, or sale of assets
        </p>
        <p>
          We do not sell personal information.
        </p>
        <br />
        <h2>
          <u>4. Legal Basis for Processing (GDPR / UK GDPR)</u>
        </h2>
        <p>
          If you are located in the EU, EEA, or UK, we process personal information based on:
        </p>
        <ul>
          <li>
            <p>Performance of a contract</p>
          </li>
          <li>
            <p>Legitimate interests (such as improving services and preventing fraud)</p>
          </li>
          <li>
            <p>Consent (where required)</p>
          </li>
          <li>
            <p>Legal obligations</p>
          </li>
        </ul>
        <br />
        <h2>
          <u>5. Your Rights</u>
        </h2>
        <p>
          Depending on your jurisdiction, you may have the right to:
        </p>
        <ul>
          <li>
            <p>Access your personal information</p>
          </li>
          <li>
            <p>Correct inaccurate or incomplete information</p>
          </li>
          <li>
            <p>Request deletion of personal information</p>
          </li>
          <li>
            <p>Restrict or object to certain processing</p>
          </li>
          <li>
            <p>Request data portability</p>
          </li>
          <li>
            <p>Withdraw consent where processing is based on consent</p>
          </li>
        </ul>
        <p>
          To exercise your rights, contact us at <a
            href="mailto:privacy.passionstocks@hey.com"
            style={{ color: 'red', textDecoration: 'underline' }}
          >
            privacy.passionstocks@hey.com
          </a>. We will respond as required by law.
        </p>
        <br />
        <h2>
          <u>6. Data Retention</u>
        </h2>
        <p>
          We retain personal information only for as long as necessary to:
        </p>
        <ul>
          <li>
            <p>Provide the Platform and related services</p>
          </li>
          <li>
            <p>Comply with legal, regulatory, or accounting requirements</p>
          </li>
          <li>
            <p>Resolve disputes and enforce agreements</p>
          </li>
        </ul>
        <p>
          When information is no longer required, it is securely deleted or anonymized.
        </p>
        <br />
        <h2>
          <u>7. Security</u>
        </h2>
        <p>
          We use reasonable administrative, technical, and organizational safeguards to protect personal information. However, no system is completely secure, and we cannot guarantee absolute security.
        </p>
        <br />
        <h2>
          <u>8. International Transfers</u>
        </h2>
        <p>
          Your information may be transferred to and processed in the United States or other jurisdictions where data protection laws may differ. Where required, we implement appropriate safeguards for international transfers.
        </p>
        <br />
        <h2>
          <u>9. Cookies &amp; Tracking</u>
        </h2>
        <p>
          We use cookies and similar technologies to enable Platform functionality, analyze usage, and improve user experience. You can manage cookies through your browser settings. Additional details may be provided in a separate Cookie Policy.
        </p>
        <br />
        <h2>
          <u>10. Children&rsquo;s Privacy</u>
        </h2>
        <p>
          The Platform is not intended for children under the age of 13 (or under 16 where applicable law requires). We do not knowingly collect personal information from children. If such information is identified, we will take steps to delete it.
        </p>
        <br />
        <h2>
          <u>11. Changes to This Privacy Policy</u>
        </h2>
        <p>
          We may update this Privacy Policy from time to time. Material changes will be communicated through the Platform, by email, or upon your next interaction with the Platform.
        </p>
        <br />
        <h2>
          <u>12. Contact Us</u>
        </h2>
        <p>
          If you have questions or concerns about this Privacy Policy or your personal information, please contact us at:
        </p>
        <p>
          <strong>PassionStocks Inc.</strong><br />
          Business address: 149 Commonwealth Drive, Menlo Park, California 94025, United States<br />
          📧 <a
            href="mailto:privacy.passionstocks@hey.com"
            style={{ color: 'red', textDecoration: 'underline' }}
          >
            privacy.passionstocks@hey.com
          </a>
        </p>
        <br />
      </div>
    </div>
  );
}


